var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 117.533,
    height: 108.048,
    viewBox: "0 0 117.533 108.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2107",
    "data-name": "Rectangle 2107",
    width: 117.533,
    height: 108.048,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2573",
    "data-name": "Groupe 2573",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2971",
    "data-name": "Trac\\xE9 2971",
    d: "M96.611,26.4a7.1,7.1,0,0,0-5.18-2.22H22.362a7.588,7.588,0,0,0-7.4,7.4v69.068a7.588,7.588,0,0,0,7.4,7.4H91.43a7.588,7.588,0,0,0,7.4-7.4V31.58a7.1,7.1,0,0,0-2.22-5.18M91.43,98.354a2.307,2.307,0,0,1-2.294,2.294H24.656a2.29,2.29,0,0,1-2.294-2.286V33.874a2.29,2.29,0,0,1,2.286-2.294H89.136a2.307,2.307,0,0,1,2.294,2.294Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2972",
    "data-name": "Trac\\xE9 2972",
    d: "M47.276,43.448a7.445,7.445,0,1,1,0-.011v.011"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2973",
    "data-name": "Trac\\xE9 2973",
    d: "M82.994,82.709H29.861a3.926,3.926,0,0,1-3.231-6.167L42.937,55.5a3.892,3.892,0,0,1,5.415-.987l.036.025,1.11.765,6.167,4.317,1.159.814c.025.025.049.025.074.049.148.1.3.173.469.271h.025a3.9,3.9,0,0,0,4.884-1.283l8.831-12.506a3.3,3.3,0,0,1,.863-.888A3.944,3.944,0,0,1,78.112,48.2l.025.074,3.922,13.37,2.171,7.4,2.565,8.708A3.941,3.941,0,0,1,84,82.576,3.992,3.992,0,0,1,83,82.709"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2974",
    "data-name": "Trac\\xE9 2974",
    d: "M7.4,89.923V19.183a2.883,2.883,0,0,1,2.87-2.87H81.01a2.868,2.868,0,0,0,2.87-2.86v-1.68a2.868,2.868,0,0,0-2.87-2.86H7.41a7.14,7.14,0,0,0-5.18,2.22,7.1,7.1,0,0,0-2.22,5.18L0,89.923a2.868,2.868,0,0,0,2.87,2.86H4.54a2.859,2.859,0,0,0,2.86-2.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2975",
    "data-name": "Trac\\xE9 2975",
    d: "M101.534,0V4.207a8.192,8.192,0,0,0-3.81,5.035q5.333,0,5.333,5.665,0,5.831-5.863,5.83-5.765,0-5.764-6.923,0-10.766,10.1-13.814M116.01,0V4.207a8.065,8.065,0,0,0-3.777,5.035q5.3,0,5.3,5.665,0,5.831-5.864,5.83-5.763,0-5.764-6.923,0-10.734,10.1-13.814",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2976",
    "data-name": "Trac\\xE9 2976",
    d: "M82.929,96.783h-53a4,4,0,1,1,0-8h53a4,4,0,0,1,0,8",
    fill: "#d0d0d0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.b8a5d31798798832b5dc5efb35b25961.svg";
export { ForwardRef as ReactComponent };